<router-outlet></router-outlet>
<app-cookie-consent></app-cookie-consent>
<app-tool-overlay></app-tool-overlay>
<p-toast [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'300ms'" [hideTransitionOptions]="'300ms'"
  [showTransformOptions]="'translateX(100%)'" styleClass="mt-7"></p-toast>
<p-confirmDialog [closable]="false" [draggable]="false"></p-confirmDialog>